import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Tooltip,
  DialogTitle,
} from "@material-ui/core";
import QRCode from "react-qr-code";

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
  qrCodeScanner: {
    color: "#3788d8",
    margin: theme.spacing(1),
  },
}));

const AppointmentCancelConfirmation = (props) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Box display="flex" justifyContent="flex-end">
      <Tooltip title="Appointment QR code" arrow>
        <div
          variant="rounded"
          className={classes.qrCodeScanner}
          onClick={handleClick}
        >
          <i class="fas fa-qrcode"></i>
        </div>
        </Tooltip>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Scan qr code to check in"}
        </DialogTitle>
        <DialogContent>
          <Box borderColor="grey.500"  p= {4}>
            <QRCode value={props.id} />
          </Box>
        </DialogContent>
        <DialogActions>
          
            <Button autoFocus onClick={handleClose} color="primary">
              Cancel
            </Button>
          
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AppointmentCancelConfirmation;
